import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';
import { ECN_CONTENT_LIST } from 'functions/ecn';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Drawer from '@material-ui/core/Drawer';
import TextField from '@material-ui/core/TextField';
import ModalService from 'services/modal';

function EcnDetail(props) {
  const Config = {
    purchase: {
      title: 'ECN报告详情',
      apiPath: '/vecn/getDetail',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Ecn_Report_Status',
          subKey: 'reportStatus',
          value: 'reportStatusName'
        }
      ],
      idField: 'reportXkNo',
      wfmCode: '1015'
    },
    sale: {
      title: 'ECN报告详情',
      apiPath: '/ecn/ecnReport/detail',
      customerNameKey: 'companyName',
      vendorNameKey: 'innerCustomerName',
      arrEnumField: [
        {
          mainKey: 'B02_Ecn_Report_Status',
          subKey: 'reportStatus',
          value: 'reportStatusName'
        }
      ],
      idField: 'reportXkNo'
    }
  };
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    moreSign1,
    moreSign2,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setError,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });

  const [companyParams, setCompanyParams] = useState({});
  const [detailList, setDetailList] = useState([]);
  const [sqmDesc, setSqmDesc] = useState('');
  const [iqcDesc, setIqcDesc] = useState('');
  const [auditIsedit, setAuditIsedit] = useState(0);
  const [reportRdDesc, setReportRdDesc] = useState('');
  const [reportQcmDesc, setReportQcmDesc] = useState('');
  const [reportIqcDesc, setReportIqcDesc] = useState('');

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  //处理详情数据
  self.afterGetDetail = function (data) {
    if (self.isPurchase) {
      data.status = data.reportStatus;
    }
    let contentList = data.contentList || [];
    let ECNCheckList = Util.clone(ECN_CONTENT_LIST);
    contentList.forEach((item, i) => {
      let checkList = [];
      checkList = item.changeOption.split(',');
      item.changeOptionList = item.changeOption.split(',').map(Number);
      item.ECNCheckArr = ECNCheckList[i].ECNCheckArr;
      item.ECNName = ECNCheckList[i].ECNName;
      item.ECNCheckArr.forEach((row, j) => {
        checkList.forEach(index => {
          if (j === parseInt(index, 10)) {
            row.Flag = true;
          }
        });
      });
    });

    let Ccode = self.isPurchase ? companyCode : data.customerCode;
    CompanyService.getCompanyParamsByCodes(Ccode, [
      'Enc_Sqm_Description',
      'Enc_Iqc_Description'
    ]).then(rs => {
      rs.forEach(item => {
        if (item.paramCode === 'Enc_Sqm_Description') {
          setSqmDesc(item.remark);
        } else if (item.paramCode === 'Enc_Iqc_Description') {
          setIqcDesc(item.remark);
        }
      });
    });
    if (Array.isArray(data.rdFiles)) {
      data.rdFiles.forEach(item => {
        item.fileUrl = CompanyService.genDownloadUrl(
          item.fileUrl,
          true,
          self.id,
          '0'
        );
        item.iqcFiles = CompanyService.genDownloadUrl(
          item.fileUrl,
          true,
          self.id,
          '0'
        );
      });
    }
    if (Array.isArray(data.qcmFiles)) {
      data.qcmFiles.forEach(item => {
        item.fileUrl = CompanyService.genDownloadUrl(
          item.fileUrl,
          true,
          self.id,
          '0'
        );
      });
    }

    getEcnProductPrintList(data);
    getEcnFileNameList(data);
    setDetailList(contentList);
    setDetail(data);
  };

  function getEcnProductPrintList(data) {
    let postbody = {
      companyCode: companyCode,
      reportXkNo: self.id,
      apiPath: '/vecn/getProductListPageResp'
    };

    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success && response.data) {
        data.productList = response.data.list || [];
        setDetail(data);
      }
    });
  }

  //获取采购方配置的文件名
  function getEcnFileNameList(data) {
    if (data.reportStatus > 0) {
      let Ccode = self.isPurchase ? data.vendorCode : companyCode;
      data.ecnReportConfigList.forEach(item => {
        let businessKey;
        businessKey = self.id + '_' + item.accessoryId;
        CompanyService.getFileList(44, businessKey, '0', '0', Ccode).then(
          list => {
            item.fileMd5s = list?.map(row => row.fileMd5) || [];
          }
        );
      });
    }
  }

  function audit() {
    let postbody = {
      companyCode: companyCode,
      reportXkNo: detail.reportXkNo,
      operateType: 2,
      apiPath: '/vecn/audit'
    };
    if (auditIsedit === 2) {
      postbody.ecnTypeAction = 'wQcm';
      postbody.reportQcmDesc = reportQcmDesc;
      postbody.reportQcmStatus = detail.reportQcmStatus;
      if (Util.isEmpty(postbody.reportQcmStatus)) {
        ModalService.showError('请选择质量管理审核结果', dispatch);
        return;
      }
      if (Util.isEmpty(postbody.reportQcmDesc)) {
        ModalService.showError('质量管理审核结果描述不能为空', dispatch);
        return;
      }
    } else if (auditIsedit === 1) {
      postbody.ecnTypeAction = 'wRd';
      postbody.reportRdDesc = reportRdDesc;
      postbody.reportRdStatus = detail.reportRdStatus;
      if (Util.isEmpty(postbody.reportRdStatus)) {
        ModalService.showError('请选择R&D审核结果', dispatch);
        return;
      }
      if (Util.isEmpty(postbody.reportRdDesc)) {
        ModalService.showError('R&D审核结果描述不能为空', dispatch);
        return;
      }
    } else if (auditIsedit === 3) {
      postbody.ecnTypeAction = 'wIqc';
      postbody.reportIqcDesc = reportIqcDesc;
      postbody.reportIqcStatus = detail.reportIqcStatus;
      if (Util.isEmpty(postbody.reportIqcStatus)) {
        ModalService.showError('请选择IQC审核结果', dispatch);
        return;
      }
      if (Util.isEmpty(postbody.reportIqcDesc)) {
        ModalService.showError('IQC审核结果描述不能为空', dispatch);
        return;
      }
    }

    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        ModalService.showTip('保存成功', dispatch);
        setAuditIsedit(0);
        self.getDetail();
      }
    });
  }

  function handleRadioChange(event) {
    let name = '';
    if (auditIsedit === 1) {
      name = 'reportRdStatus';
    } else if (auditIsedit === 2) {
      name = 'reportQcmStatus';
    } else if (auditIsedit === 3) {
      name = 'reportIqcStatus';
    }
    detail[name] = event.target.value;
  }

  function handleDescChange(event) {
    if (auditIsedit === 1) {
      setReportRdDesc(event.target.value);
    } else if (auditIsedit === 2) {
      setReportQcmDesc(event.target.value);
    } else if (auditIsedit === 3) {
      setReportIqcDesc(event.target.value);
    }
  }

  function handleBoxState(idx) {
    boxState[idx] = !boxState[idx];
    setBoxState(boxState);
    forceUpdate();
  }

  function showFileList(item, businessType) {
    const { actions } = props;
    if (businessType === 40) {
      setFileList(detail.rdFiles);
    } else if (businessType === 41) {
      setFileList(detail.qcmFiles);
    } else if (businessType === 42) {
      setFileList(detail.iqcFiles);
    } else if (businessType === 44) {
      let businessKey = self.id + '_' + item.accessoryId;
      let Ccode = self.isPurchase ? detail.vendorCode : companyCode;
      setShowLoading(true);
      CompanyService.getFileList(44, businessKey, businessKey, '', Ccode).then(
        res => {
          setShowLoading(false);
          if (Array.isArray(res)) {
            let arr = res.map(row => {
              return { ...row };
            });
            setFileList(arr);
          }
        }
      );
    }
    actions.openDownloadModal();
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="pb50">
        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>基础信息</label>
          </div>
          <ul>
            {self.isPurchase && (
              <li>
                <label className="order-detail-label">供应商</label>
                <div className="order-detail-value">
                  {detail.innerVendorName}({detail.innerVendorCode})
                </div>
              </li>
            )}
            {!self.isPurchase && (
              <li>
                <label className="order-detail-label">客户名称</label>
                <div className="order-detail-value">
                  {detail.customerName}({detail.innerCustomerCode})
                </div>
              </li>
            )}
            <li>
              <label className="order-detail-label">报告编号</label>
              <div className="order-detail-value">{detail.reportXkNo}</div>
            </li>
            <li>
              <label className="order-detail-label">报告人</label>
              <div className="order-detail-value">
                {detail.reportPublishName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">报告标题</label>
              <div className="order-detail-value">{detail.reportTitle}</div>
            </li>
            <li>
              <label className="order-detail-label">变更日期</label>
              <div className="order-detail-value">
                {formatDate(detail.changeDate, 'YYYY-MM-DD HH:mm')}
              </div>
            </li>
            <li>
              <label className="order-detail-label">报告日期</label>
              <div className="order-detail-value">
                {formatDate(detail.reportPublishTime, 'YYYY-MM-DD HH:mm')}
              </div>
            </li>
            <li>
              <label className="order-detail-label">状态</label>
              <div
                className={
                  'u-sign ' +
                  CommonFns.getStatusClass('ECN', detail.reportStatus)
                }
              >
                {detail.reportStatusName}
              </div>
            </li>

            {/* 审批流状态 仅开启后才显示 */}
            {self.isPurchase && updateTs > 0 && workflow.isActive && (
              <li>
                <label className="order-detail-label">审批环节</label>
                <div className="order-detail-value">
                  <WorkflowStatus
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                  />
                </div>
              </li>
            )}
            {/* 审批流按钮 */}
            {self.isPurchase && updateTs > 0 && workflow.isActive && (
              <li>
                <label className="order-detail-label">审批操作</label>
                <div className="order-detail-value">
                  <WorkflowButtons
                    companyCode={companyCode}
                    id={self.id}
                    workflow={workflow}
                    detail={detail}
                    onChange={() => {
                      self.getDetail();
                    }}
                  />
                </div>
              </li>
            )}
          </ul>
          {/* <div
            className={moreSign1 ? 'm-more' : 'm-more m-more-open'}
            onClick={() => {
              handleMore(1);
            }}
          >
            {moreSign1 && '更多'}
            {!moreSign1 && '收起'}
            <i className="icon-down"></i>
          </div> */}
        </div>

        {/*8D报告单 */}
        {!Util.isEmpty(detail.productList) && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div
                className={
                  !boxState[1]
                    ? 'order-detail-title m-more'
                    : 'order-detail-title m-more m-more-open'
                }
              >
                <label>ECN物料</label>
                <i className="icon-down" onClick={() => handleBoxState(1)}></i>
              </div>
              {boxState[1] && (
                <div className="order-detail-list">
                  <ul>
                    {detail.productList.map((item, index) => (
                      <li className="order-detail-item" key={index}>
                        <span className="lineNo">
                          {item.itemCode} {item.itemName}
                        </span>
                        <ul className="clearfix">
                          <li>
                            物料编码：<span>{item.productCode}</span>
                          </li>
                          <li>
                            物料名称：<span>{item.productName}</span>
                          </li>
                          <li>
                            物料规格：
                            <span>{item.productScale}</span>
                          </li>
                          <li>
                            未完成订单数：
                            <span>{item.unfinishedOrderNum}</span>
                          </li>
                          <li>
                            未完待交数量：
                            <span>{item.unfinishedWaitNum}</span>
                          </li>
                        </ul>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}

        {!Util.isEmpty(detailList) && updateTs > 0 && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div className="order-detail-title">
                {/* <label>改善跟踪</label> */}
              </div>
              <div className="order-detail-list">
                <ul>
                  {detailList.map((item, index) => (
                    <li className="order-detail-item" key={index}>
                      <span className="lineNo">
                        {index + 1}.{item.ECNName}
                      </span>
                      <ul className="clearfix">
                        <li className="single">
                          {!Util.isEmpty(item.ECNCheckArr) &&
                            item.ECNCheckArr.map((row, i) => (
                              // <FormGroup key={i}>
                              <FormControlLabel
                                key={i}
                                control={
                                  <Checkbox
                                    color="primary"
                                    icon={
                                      <CheckBoxOutlineBlankIcon fontSize="small" />
                                    }
                                    checkedIcon={
                                      <CheckBoxIcon fontSize="small" />
                                    }
                                  />
                                }
                                checked={row.Flag ? true : false}
                                label={row.name}
                              />
                              // </FormGroup>
                            ))}
                        </li>
                        <li>
                          变更前：
                          <span>{item.changeBefore}</span>
                        </li>
                        <li>
                          变更后：
                          <span>{item.changeAfter}</span>
                        </li>
                        <li>
                          变更原因：
                          <span>{item.changeReason}</span>
                        </li>
                      </ul>
                    </li>
                  ))}
                </ul>
                <ul>
                  <li className="order-detail-item">
                    附件：
                    {!Util.isEmpty(detail.ecnReportConfigList) &&
                      detail.ecnReportConfigList.map((item, i) => (
                        <ul className="clearfix" key={i}>
                          <li className="single">
                            附件{item.accessoryId}-{item.accessoryName}:
                            <span>
                              {!Util.isEmpty(item.fileMd5s) && (
                                <span
                                  className="attachment"
                                  onClick={() => showFileList(item, 44)}
                                >
                                  {item.fileMd5s?.length}个附件
                                  <i className="icon-attachment"></i>
                                </span>
                              )}
                            </span>
                          </li>
                        </ul>
                      ))}
                  </li>
                </ul>

                {/* <ul>
                  <li className="order-detail-item">
                    质量判定：
                    <ul className="clearfix">
                      <li className="single">
                        R&D工程审核结果：
                        <span>{detail.reportRdDesc}</span>
                      </li>
                    </ul>
                  </li>
                </ul> */}
              </div>
            </div>
          </div>
        )}

        {
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div className="order-detail-title">
                <label>质量判定</label>
              </div>
              <div className="order-detail-list">
                <ul>
                  <li className="order-detail-item">
                    R&D工程审核
                    <ul className="clearfix">
                      <li className="single">
                        审核结果：<span>{detail.reportRdDesc}</span>
                      </li>
                      <li className="single">
                        附件：
                        <span>
                          {!Util.isEmpty(detail.rdFiles) && (
                            <span
                              className="attachment"
                              onClick={() => showFileList(detail, 40)}
                            >
                              {detail.rdFiles?.length}个附件
                              <i className="icon-attachment"></i>
                            </span>
                          )}
                        </span>
                      </li>
                      <li className="single">
                        审核说明：<span>{iqcDesc}</span>
                      </li>
                      <li className="single">
                        是否合格：
                        <span>
                          {detail.reportRdStatus === 1
                            ? '合格'
                            : detail.reportRdStatus === 0
                            ? '不合格'
                            : ''}
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>
                <ul>
                  <li className="order-detail-item">
                    质量管理审核
                    <ul className="clearfix">
                      <li className="single">
                        审核结果：<span>{detail.reportQcmDesc}</span>
                      </li>
                      <li className="single">
                        附件：
                        <span>
                          {!Util.isEmpty(detail.qcmFiles) && (
                            <span
                              className="attachment"
                              onClick={() => showFileList(detail, 41)}
                            >
                              {detail.qcmFiles?.length}个附件
                              <i className="icon-attachment"></i>
                            </span>
                          )}
                        </span>
                      </li>
                      <li className="single">
                        审核说明：<span>{sqmDesc}</span>
                      </li>
                      <li className="single">
                        是否合格：
                        <span>
                          {detail.reportQcmStatus === 1
                            ? '合格'
                            : detail.reportQcmStatus === 0
                            ? '不合格'
                            : ''}
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>
                <ul>
                  <li className="order-detail-item">
                    IQC检验
                    <ul className="clearfix">
                      <li className="single">
                        检验结果：<span>{detail.reportIqcDesc}</span>
                      </li>
                      <li className="single">
                        附件：
                        <span>
                          {!Util.isEmpty(detail.iqcFiles) && (
                            <span
                              className="attachment"
                              onClick={() => showFileList(detail, 42)}
                            >
                              {detail.iqcFiles?.length}个附件
                              <i className="icon-attachment"></i>
                            </span>
                          )}
                        </span>
                      </li>
                      <li className="single">
                        审核说明：<span>{iqcDesc}</span>
                      </li>
                      <li className="single">
                        是否合格：
                        <span>
                          {detail.reportIqcStatus === 1
                            ? '合格'
                            : detail.reportIqcStatus === 0
                            ? '不合格'
                            : ''}
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        }

        {[4, 7, 8].indexOf(detail.reportStatus) > -1 && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div className="order-detail-title">
                <label>报告结案</label>
              </div>
              <div className="order-detail-list">
                <ul>
                  <li className="order-detail-item">
                    <ul className="clearfix">
                      <li className="single">
                        结案说明：<span>{detail.reportCloseDesc}</span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>

      <Drawer
        anchor="bottom"
        open={auditIsedit !== 0}
        onClose={() => setAuditIsedit(false)}
      >
        <div tabIndex={0} role="button">
          <div className="MuiDrawer-paper">
            <div className="text-field-item">
              {auditIsedit === 1 && (
                <TextField
                  label="审核结果"
                  value={reportRdDesc}
                  onChange={event => handleDescChange(event)}
                  margin="normal"
                  variant="outlined"
                />
              )}
              {auditIsedit === 2 && (
                <TextField
                  label="审核结果"
                  value={reportQcmDesc}
                  onChange={event => handleDescChange(event)}
                  margin="normal"
                  variant="outlined"
                />
              )}
              {auditIsedit === 3 && (
                <TextField
                  label="审核结果"
                  value={reportIqcDesc}
                  onChange={event => handleDescChange(event)}
                  margin="normal"
                  variant="outlined"
                />
              )}
            </div>
            <div className="text-field-item">
              <RadioGroup
                aria-label="quiz"
                name="quiz"
                value={
                  auditIsedit === 1
                    ? detail.reportRdStatus
                    : auditIsedit === 2
                    ? detail.reportQcmStatus
                    : auditIsedit === 3
                    ? detail.reportIqcStatus
                    : undefined
                }
                onChange={event => handleRadioChange(event)}
              >
                <FormControlLabel
                  value="1"
                  control={<Radio color="primary" />}
                  label="合格"
                />
                <FormControlLabel
                  value="0"
                  control={<Radio color="primary" />}
                  label="不合格"
                />
              </RadioGroup>
            </div>
            <p className="mt15 m-flex-box">
              <Button
                type="default"
                onClick={() => audit()}
                className="m-flex-item u-btn u-btn_primary"
              >
                确定
              </Button>
              <Button
                type="default"
                onClick={() => setAuditIsedit(0)}
                className="m-flex-item u-btn u-btn_line"
              >
                取消
              </Button>
            </p>
          </div>
        </div>
      </Drawer>

      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {detail.reportStatus === 9 &&
            User.checkAuth('10051607') &&
            workflow.data &&
            workflow.data['ecn_audit_rd']?.complete && (
              <Button
                type="default"
                onClick={() => {
                  setAuditIsedit(1);
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                R&D工程审核
              </Button>
            )}
          {detail.reportStatus === 1 &&
            User.checkAuth('10051602') &&
            workflow.data &&
            workflow.data['ecn_audit_sqm']?.complete && (
              <Button
                type="default"
                onClick={() => {
                  setAuditIsedit(2);
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                质量管理审核
              </Button>
            )}
          {detail.reportStatus === 2 &&
            User.checkAuth('10051603') &&
            workflow.data &&
            workflow.data['ecn_audit_iqc']?.complete && (
              <Button
                type="default"
                onClick={() => {
                  setAuditIsedit(3);
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                IQC审核
              </Button>
            )}
        </div>
      )}
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
      <Modal></Modal>
    </div>
  );
}
EcnDetail.propTypes = {
  actions: PropTypes.object.isRequired
};
const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EcnDetail);
